module.exports = __webpack_public_path__ + "img/gnb_logo.dd1a53c5.png";